module.exports = __webpack_public_path__ + "img/logo-2019.bec4cce5.svg";